export default __webpack_public_path__ + "assets/png/952326f94287699b744377202cbd83fe.png";